"use client";

import React from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import { DrawerOverlay, DrawerPortal } from "../parts";
import { useDrawer } from "../provider";
import { type DrawerContentProps, drawerContentVariants } from "../types";

function DrawerContent({ className, children, ...props }: DrawerContentProps) {
  const { direction } = useDrawer();
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <DrawerPortal>
      <DrawerOverlay />
      <DrawerPrimitive.Content
        data-slot="drawer-content"
        className={cn(
          drawerContentVariants({
            direction,
            className: cn(className, classes),
          }),
        )}
        {...native}
      >
        {/* <div className='mx-auto mt-4 h-2 rounded-full w-[100px] bg-muted' /> */}
        {children}
      </DrawerPrimitive.Content>
    </DrawerPortal>
  );
}

DrawerContent.displayName = "Drawer.Content";

export default DrawerContent;
